import { Component } from '@angular/core';

@Component({
  selector: 'pet-market-modelling',
  template: `
  <hr>  
  <h2>
      market-modelling works!
    </h2>
    <div style="text-align: right;">
      <button class="btn btn-secondary" (click)="goBack()">
        <i class="fa fa-arrow-left"></i> Back
      </button>
    </div>
  `,
  styles: ``
})
export class MarketModellingComponent {
  public goBack() {
    window.history.back();
  }
}
